"use client";

import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";
import { APP_VERSION } from "@/lib/constants";

export function Footer() {
  const t = useTranslations();

  return (
    <footer
      className="py-10 text-center border-t border-border/50 mt-8"
      data-testid="app-footer"
    >
      <p className="text-sm text-muted-foreground" data-testid="footer-text">
        {t("footer_text", { year: new Date().getFullYear() })} | v{APP_VERSION}
      </p>
      <p
        className="text-xs text-muted-foreground mt-2"
        data-testid="footer-subtext"
      >
        {t("footer_sub")}
      </p>
      <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 mt-3 text-xs">
        <Link
          href="/about"
          className="hover:text-primary transition-colors cursor-pointer"
        >
          {t("footer_about")}
        </Link>
        <span className="text-muted-foreground/50">|</span>
        <Link
          href="/contact"
          className="hover:text-primary transition-colors cursor-pointer"
        >
          {t("footer_contact")}
        </Link>
        <span className="text-muted-foreground/50">|</span>
        <Link
          href="/sitemap-page"
          className="hover:text-primary transition-colors cursor-pointer"
        >
          {t("footer_sitemap")}
        </Link>
        <span className="text-muted-foreground/50">|</span>
        <Link
          href="/privacy"
          className="hover:text-primary transition-colors cursor-pointer"
        >
          {t("footer_privacy")}
        </Link>
        <span className="text-muted-foreground/50">|</span>
        <Link
          href="/terms"
          className="hover:text-primary transition-colors cursor-pointer"
        >
          {t("footer_terms")}
        </Link>
      </div>
    </footer>
  );
}
